import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbsLink from './BreadcrumbsLink';
import BreadcrumbsLabel from './BreadcrumbsLabel';

/**
 * A single breadcrumb item.
 */
const BreadcrumbsItem = (props) => {
  const Comp = props.href ? BreadcrumbsLink : BreadcrumbsLabel;
  return (
    <li className="c-breadcrumbs__list-item">
      <Comp {...props} />
    </li>
  );
};

export default BreadcrumbsItem;

BreadcrumbsItem.propTypes = {
  href: PropTypes.string,
};

BreadcrumbsItem.defaultProps = {
  href: null,
};
